import axios from "axios";

const BASE_URL = "https://dqrwhd91dh.execute-api.us-east-1.amazonaws.com/dev";
const CLIENT_BASE_URL =
  "https://h6ztjbuxo1.execute-api.us-east-1.amazonaws.com/dev";

export const getClientProcess = async (
  cnpj: string,
  nextCursor: string | null
) => {
  let url = `${BASE_URL}/process/client?cnpj=${encodeURIComponent(cnpj)}`;
  const params = new URLSearchParams();

  if (nextCursor) {
    params.append("cursor", nextCursor);
  }

  if (params.toString()) {
    url += `&${params.toString()}`;
  }

  const response = await axios.get(url);
  return response.data;
};

export const associateProcessByEmail = async (
  codigo: string,
  email: string | null,
  token: string
) => {
  const endpoint = `${BASE_URL}/process/associate`;
  if (!email) {
    throw new Error("Email não pode ser null");
  }

  const body = {
    CD_PROCESSO: codigo,
    EMAIL: email,
  };

  try {
    const response = await axios.post(endpoint, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao associar processo:", error);
    throw error;
  }
};

export const desassociateProcessByEmail = async (
  codigo: string,
  email: string | null
) => {
  const endpoint = `${BASE_URL}/process/associate`;

  if (!email) {
    throw new Error("Email não pode ser null");
  }

  const body = {
    CD_PROCESSO: codigo,
    EMAIL: email,
  };

  try {
    const response = await axios.delete(endpoint, { data: body });
    return response.data;
  } catch (error) {
    console.error("Erro ao desassociar processo:", error);
    throw error;
  }
};

export const favoritarProcessByEmail = async (
  codigo: string,
  email: string | null,
  token: string
) => {
  const endpoint = `${BASE_URL}/process/associate/client`;
  if (!email) {
    throw new Error("Email não pode ser null");
  }

  const body = {
    CD_PROCESSO: codigo,
    EMAIL: email,
  };

  try {
    const response = await axios.post(endpoint, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao associar processo:", error);
    throw error;
  }
};

export const desfavoritarProcessByEmail = async (
  codigo: string,
  email: string | null
) => {
  const endpoint = `${BASE_URL}/process/associate/client`;

  if (!email) {
    throw new Error("Email não pode ser null");
  }

  const body = {
    CD_PROCESSO: codigo,
    EMAIL: email,
  };

  try {
    const response = await axios.delete(endpoint, { data: body });
    return response.data;
  } catch (error) {
    console.error("Erro ao desfavoritar processo:", error);
    throw error;
  }
};

export const getUsersByGroup = async (group: string) => {
  let url = `${CLIENT_BASE_URL}/user/all?group=${group}`;

  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Erro ao consultar usuários por grupo:", error);
    throw error;
  }
};

export const getAllUsers = async () => {
  let url = `${CLIENT_BASE_URL}/user/count`;

  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Erro ao consultar usuários:", error);
    throw error;
  }
};

export const getProcessUrf = async (code: string) => {
  let url = `${BASE_URL}/process/urf/${code}`;

  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Erro ao consultar urf:", error);
    throw error;
  }
};

export const deleteUser = async (email: string) => {
  let url = `${CLIENT_BASE_URL}/user/${email}`;

  try {
    const response = await axios.delete(url);
    return response.data;
  } catch (error) {
    console.error("Erro ao deletar usuário:", error);
    throw error;
  }
};

export const addUser = async (email: string, cnpj: string, type: number) => {
  let url = `${CLIENT_BASE_URL}/user`;

  const body = {
    email: email,
    cnpj: cnpj,
    type: type,
  };

  try {
    const response = await axios.post(url, body);
    return response.data;
  } catch (error) {
    console.error("Erro ao deletar usuário:", error);
    throw error;
  }
};

export const getProcessbyCode = async (code: string) => {
  const endpoint = `${BASE_URL}/process/${code}`;
  const response = await axios.get(endpoint);
  return response.data;
};

export const getClientByCnpj = async (cnpj: string) => {
  let url = `${CLIENT_BASE_URL}/client?cnpj=${encodeURIComponent(cnpj)}`;

  const response = await axios.get(url);
  return response.data;
};

export const getClientByCode = async (code: string) => {
  const endpoint = `${CLIENT_BASE_URL}/client/code/${code}`;
  const response = await axios.get(endpoint);
  return response.data;
};

export const getProcessSefazMapa = async (codigo: string) => {
  const endpoint = `${BASE_URL}/process/sefaz/${codigo}`;

  try {
    const response = await axios.get(endpoint);
    return response.data;
  } catch (error) {
    console.error("Erro ao consultar info sefaz e mapa do processo:", error);
    throw error;
  }
};

export const getAllClients = async (nextCursor: string | null) => {
  const endpoint = `${CLIENT_BASE_URL}/client/all`;

  const url = nextCursor ? `${endpoint}?cursor=${nextCursor}` : endpoint;

  const response = await axios.get(url);
  return response.data;
};

export const getAllProcesses = async (nextCursor: string | null) => {
  const endpoint = `${BASE_URL}/process/all`;

  const url = nextCursor ? `${endpoint}?cursor=${nextCursor}` : endpoint;

  const response = await axios.get(url);
  return response.data;
};

export const getAllProcessesByEmail = async (
  email: string | null,
  nextCursor?: string | null,
  itemsPerPage?: number,
  isClient?: boolean
) => {
  if (!email) throw new Error("Email é obrigatório.");

  let url = `${BASE_URL}/process/all/${email}`;
  const params = new URLSearchParams();

  if (itemsPerPage) {
    params.append("itemsPerPage", itemsPerPage.toString());
  }

  if (nextCursor) {
    params.append("cursor", nextCursor);
  }

  if (isClient) {
    params.append("isClient", String(isClient));
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await axios.get(url);
  return response.data;
};

export const searchProcess = async (
  type: 1 | 2 | 3 | 4,
  value: string,
  client?: string
) => {
  if (!value) throw new Error("O valor de busca é obrigatório.");

  const params = new URLSearchParams();
  params.append("type", type.toString());
  params.append("value", value);

  if (client) {
    params.append("client", client);
  }

  const url = `${BASE_URL}/process/search?${params.toString()}`;
  const response = await axios.get(url);
  return response.data;
};

export const getUserByEmail = async (email: string | null) => {
  const endpoint = `${CLIENT_BASE_URL}/user/${email}`;
  const response = await axios.get(endpoint);
  return response.data;
};
